module.exports = __webpack_public_path__ + "img/customer.46ddc760.png";